import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HasSubscriptions } from 'shared/components/higher-order/has-subscriptions';
import { ToastService } from 'shared/services/toast.service';

@Component({
  selector: 'app-infopost-nav-container',
  templateUrl: './infopost-nav-container.component.html',
  styleUrl: './infopost-nav-container.component.scss',
})
export class InfopostNavContainerComponent extends HasSubscriptions implements OnInit, OnDestroy {
  @Input()
  menuItemType: string;

  @Input()
  title: string;

  @Input()
  noHeader: boolean;

  @Input()
  hideActions: boolean;

  @Input()
  contentLoading$: Observable<boolean>;

  @Input()
  processingActionsHeight = '64px';

  @Input()
  processingActionsPadding = '12px 28px';

  // Error Inputs
  @Input()
  error$: Observable<Error | Array<Error>>;
  @Input()
  errorToastMessage = 'Failed to retrieve data. Please try again.';
  @Input()
  shouldShowErrorPanel = false;
  @Input()
  shouldShowErrorPanelButton = false;
  @Input()
  errorPanelMainMessage = 'Uh oh! Something went wrong...';
  @Input()
  errorPanelSubMessage =
    'We ran into some trouble trying to load this page. Please try loading it again.';
  @Input()
  errorPanelIconClass = 'icon-dead';

  @Input()
  noYScroll: boolean;

  @Input()
  removeRightPadding: boolean;

  @Input()
  onScroll;

  contentArea: string;
  processingActionsClasses: string;

  areFilteredErrors$: Observable<boolean> = of(false);
  currentYear =  new Date().getFullYear();

  constructor(private _toastService: ToastService) {
    super();
  }

  setScrollClasses() {
    this.contentArea = this.noYScroll ? 'content-area no-Y-scroll' : 'content-area Y-scroll';
  }

  ngOnInit() {
    this.setScrollClasses();
  }

  ngOnDestroy() {
    return super.ngOnDestroy();
  }
}
